import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import Trip from 'affiliates/Widget/FerrySearchMask/MultiTrip/Trip';
import SubmitBtn from 'affiliates/Widget/FerrySearchMask/SubmitBtn';

const MultiTrip = ({
  isMobile, loading, triedToSubmit, brandLogo, trips, noOfTrips, minTrips, maxTrips, popular, joinProgram, btncolor,
  errors, addTrip, removeTrip,setPort, fetchSuggestions, clearSuggestions, onSuggestionSelected, portString,
  portStringNo3Ltr, swapPorts, setTypeTrip, setDate, setDates, setPortByThreeLetterCode, submitForm,
  translations
}) => (
  <form className="searchMask multi-trip">
    <div className="grid no-gutter">
      {trips.map((trip, index) =>
        <Trip
          key={index}
          isMobile={isMobile}
          index={index}
          triedToSubmit={triedToSubmit}
          trip={trip}
          noOfTrips={noOfTrips}
          minTrips={minTrips}
          maxTrips={maxTrips}
          popular={popular}
          errors={errors}
          btncolor={btncolor}
          disableBefore={index > 0 && index - 1 < trips.length && trips[index - 1] ?
            trips[index - 1].obDate : {}}
          disableAfter={index >= 0 && index + 1 < trips.length && trips[index + 1] ? 
            trips[index + 1].obDate : {}}
          setPort={setPort}
          fetchSuggestions={fetchSuggestions}
          clearSuggestions={clearSuggestions}
          onSuggestionSelected={onSuggestionSelected}
          portString={portString}
          portStringNo3Ltr={portStringNo3Ltr}
          swapPorts={swapPorts}
          setTypeTrip={setTypeTrip}
          setDate={setDate}
          setDates={setDates}
          addTrip={addTrip}
          removeTrip={removeTrip}
          setPortByThreeLetterCode={setPortByThreeLetterCode}
          translations={translations}
        />
      )}
      <SubmitBtn
        isMobile
        loading={loading}
        brandLogo={brandLogo}
        joinProgram={joinProgram}
        btncolor={btncolor}
        submitForm={submitForm}
        translations={translations}
      />
    </div>
  </form>
);

MultiTrip.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  triedToSubmit: PropTypes.bool.isRequired,
  brandLogo: PropTypes.string.isRequired,
  trips: PropTypes.object.isRequired,
  noOfTrips: PropTypes.number.isRequired,
  minTrips: PropTypes.number.isRequired,
  maxTrips: PropTypes.number.isRequired,
  popular: PropTypes.bool.isRequired,
  joinProgram: PropTypes.bool.isRequired,
  btncolor: PropTypes.string.isRequired,
  errors: PropTypes.array.isRequired,
  addTrip: PropTypes.func.isRequired,
  removeTrip: PropTypes.func.isRequired,
  setPort: PropTypes.func.isRequired,
  fetchSuggestions: PropTypes.func.isRequired,
  clearSuggestions: PropTypes.func.isRequired,
  onSuggestionSelected: PropTypes.func.isRequired,
  portString: PropTypes.func.isRequired,
  portStringNo3Ltr: PropTypes.func.isRequired,
  swapPorts:PropTypes.func.isRequired,
  setTypeTrip: PropTypes.func.isRequired,
  setDate: PropTypes.func.isRequired,
  setDates: PropTypes.func.isRequired,
  setPortByThreeLetterCode: PropTypes.func.isRequired,
  submitForm: PropTypes.func.isRequired,
  translations: PropTypes.object.isRequired
};

export default observer(MultiTrip);
